var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"lp-builder-tDftMsSwWyDf3fY5DVAN8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["miro-site-lp-builder-pages@miro"]={id:"lp-builder-tDftMsSwWyDf3fY5DVAN8"};
      